const getConstants = require('../../../utils/getConstants');
const constants = getConstants();
const { optionIfTypes, operatorTypes, optionThenTypes } = constants;
const _ = require('../../../lodash');

class RuleEvaluator {
   constructor() {}

   evaluateOptionRules({ values, rules, allowMultiple = false }) {
      const triggeredRules = [];

      rules.forEach((rule) => {
         values.forEach((value) => {
            if (this.isRuleTriggered({ rule, value })) {
               triggeredRules.push(rule);
            }
         });
      });

      const triggeredThens = _.flatMap(triggeredRules, (rule) => rule.thens || []);

      return {
         failOp: triggeredThens.some((then) => then.idThenType === optionThenTypes.FAIL_OP.id),
         flag: triggeredThens.some((then) => then.idThenType === optionThenTypes.FLAG.id),
         score: this.calculateScore(rules, triggeredThens, allowMultiple),
         maxScore: this.calculateMaxScore(rules, allowMultiple)
      };
   }

   calculateScore(rules, triggeredThens, allowMultiple) {
      const scoredThens = triggeredThens.filter((then) => then.idThenType === optionThenTypes.SCORE.id);
      const maxScore = this.calculateMaxScore(rules, allowMultiple);

      if (maxScore == null) {
         return null;
      }

      if (scoredThens.length == 0) {
         return 0;
      }

      if (allowMultiple) {
         return scoredThens.reduce((acc, then) => acc + this.toScore(then.data?.score), 0);
      } else {
         return this.toScore(scoredThens[0].data?.score);
      }
   }

   calculateMaxScore(rules, allowMultiple) {
      const allThens = _.flatMap(rules, (rule) => rule.thens || []);
      const scoreThens = allThens.filter((then) => then.idThenType === optionThenTypes.SCORE.id);
      const scores = scoreThens.map((then) => this.toScore(then.data?.score)).filter((score) => score > 0);

      if (scores.length === 0) {
         return null;
      }

      if (allowMultiple) {
         return scores.reduce((acc, score) => acc + score, 0);
      } else {
         return Math.max(...scores);
      }
   }

   toScore(value) {
      const score = Number(value);
      return Number.isFinite(score) ? score : 0;
   }

   isRuleTriggered({ rule, value }) {
      if (!rule.ifs || rule.ifs.length === 0) return false;

      const applicableIf = rule.ifs[0];

      if (applicableIf.idIfType === optionIfTypes.ANSWER.id && applicableIf.idOperatorType === operatorTypes.EQUALS.id) {
         return value.txt === applicableIf.data?.value;
      }

      return false;
   }
}

module.exports = RuleEvaluator;
